export default function match(api){
    api.provideOMFETopic('subscribeToMatch', 'unsubscribeFromMatch', {
        topicName : ({ucsOperatorId, apiVersion, lang, matchId}) =>
            `/sports/${(apiVersion && ucsOperatorId && apiVersion >= 1 && ucsOperatorId + '/') || ''}${lang || 'en'}/match/${matchId || 0}`,
    });
}



// WEBPACK FOOTER //
// ./src/OMFECore/enhanced-webapi/api-sports/sub-match.js